// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.scribe.EncounterScribeTestResponse */
/* istanbul ignore next */
@GandalfModel
export class EncounterScribeTestResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	generatedPrompt!: string;

	@GandalfProperty({ designType: String })
	name!: string;

	@GandalfProperty({ designType: Number })
	screenDisplayOrder!: number;

	@GandalfProperty({ designType: Number })
	stepDisplayOrder!: number;

	@GandalfProperty({ designType: Number })
	testDisplayOrder!: number;

	@GandalfProperty({ designType: Number })
	workflowTestId!: number;

}
